export class CommonFunction {
  // remove space relace with '_'
  static removeSpaceAddUnderScore(str) {
    return str.replace(/\s/g, "");
  }

  // remove _ relace with ' ' (space)
  static removeUnderScoreAddSpace(str) {
    return str.replace(/_/g, " ");
  }

  static checkLogin() {
    return localStorage.getItem("user_id") ? true : false;
  }

  static logOut() {
    if (localStorage.getItem("user_id")) {
      //alert("Are you sure You want to log out ?");
      localStorage.removeItem("token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("mobile");
      localStorage.removeItem("restaurant_name");
      localStorage.removeItem("unique_id");
      return true;
    } else {
      return false;
    }
  }

  static timeConvert(time) {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }

    return time.join("");
  }

  static countDownMin(min = 5) {
    return min;
  }

  static hexToRGB(color) {
    if (color.length != 6) {
      throw "Only six-digit hex colors are allowed.";
    }

    var aRgbHex = color.match(/.{1,2}/g);
    var aRgb = {
      r: parseInt(aRgbHex[0], 16) / 255,
      g: parseInt(aRgbHex[1], 16) / 255,
      b: parseInt(aRgbHex[2], 16) / 255,
    };
    return aRgb;
  }

  static convertIntoFloat(num) {
    return parseFloat(num).toFixed(2);
  }

  static capitalize(str: string) {
    let splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  static splitArray(arr, n) {
      let result = [];
      if(arr.length <= n){
        result.push(arr);
      }else{
        let rest = arr.length % n;
        let start = 0;
        let end = n;
        let arrayEnd = arr.length - 1;

        while(start <= arrayEnd){
          if(rest != 0){
            if(end > arrayEnd){
              break;
            }
            result.push(arr.slice(start, end));
          }else{
            result.push(arr.slice(start, end));
          }
          start = end;
          end = end + n;
          console.log("start index" + start);
          console.log("end index" + end);
        }

        if(rest != 0){
          result.push(arr.slice(start));
        }
      }
      return result;
  }


  static getCloseDaysOfWeek(business_hours) {
    var days = [];
    business_hours.forEach(element => {
      if (element.day === 'Monday') {
        if (element.open_close == 1) {
          days.push(1);
        }
      } else if (element.day === 'Tuesday') {
        if (element.open_close == 1) {
          days.push(2);
        }
      } else if (element.day === 'Wednesday') {
        if (element.open_close == 1) {
          days.push(3);
        }
      } else if (element.day === 'Thursday') {
        if (element.open_close == 1) {
          days.push(4);
        }
      } else if (element.day === 'Friday') {
        if (element.open_close == 1) {
          days.push(5);
        }
      } else if (element.day === 'Saturday') {
        if (element.open_close == 1) {
          days.push(6);
        }
      } else if (element.day === 'Sunday') {
        if (element.open_close == 1) {
          days.push(0);
        }
      }
    });
    return days;
  }
}
